module.exports = __webpack_public_path__ + "img/rarity_star_normal.0e1c4fde.png";